import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../store/auth-slice";
import { resetPharmacyNamesCache } from "../services/pharmacyLookupService";
import { PortalLogoutControl } from "../components/PortalLogoutButton/PortalLogoutButton";

/**
 * Association portal logout. There is no availability to pause and no consult
 * draft to protect, so this is the session clear and nothing else; it returns
 * the same control shape as `useAdvisorLogout` so the shared button and the
 * account panel take either.
 */
export const useAssociationLogout = (): PortalLogoutControl => {
  const dispatch = useDispatch();
  const [loggingOut, setLoggingOut] = useState(false);

  const logout = useCallback(() => {
    if (loggingOut) {
      return;
    }
    setLoggingOut(true);
    // The pharmacy list cache belongs to the session that loaded it.
    resetPharmacyNamesCache();
    dispatch(authActions.logout());
  }, [dispatch, loggingOut]);

  return {
    logout,
    loggingOut,
    blockedByConsult: false,
    hasUnfinishedDraft: false,
  };
};
